import React, { useState, useEffect } from "react";
import {
  Navbar,
  Button,
  Container,
  Row,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { auth } from "../firebaseConfig";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { FaBars, FaUser, FaSignOutAlt, FaBox, FaTags, FaUserFriends, FaExternalLinkAlt } from "react-icons/fa";
import Logo from "../image/Logo_Nav.webp";

const DashboardLayout = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
    document.body.classList.toggle("no-scroll", !isToggled);
  };

  const closeSidebar = () => {
    setIsToggled(false);
    document.body.classList.remove("no-scroll");
  };

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsToggled(false);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUsername("");
      navigate("/LoginAdmin");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Close sidebar on page route change (especially on mobile)
  useEffect(() => {
    closeSidebar();
  }, [pathname]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUsername(user.email);
      } else {
        navigate("/LoginAdmin");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <div
          className={`d-flex p-0 ${isToggled ? "toggled" : ""}`}
          id="wrapper"
        >
          {/* Dark Enterprise Sidebar */}
          <div
            className={`border-end ${isToggled ? "show-sidebar" : ""}`}
            id="sidebar-wrapper"
          >
            <div className="sidebar-heading text-center d-flex align-items-center justify-content-center py-3 px-3">
              <div className="sidebar-logo-badge">
                <img src={Logo} alt="Kamdhenu Admin" style={{ height: "80px", width: "auto", objectFit: "contain", display: "block" }} />
              </div>
            </div>

            <div className="sidebar-nav-title">MAIN NAVIGATION</div>

            <div className="list-group list-group-flush px-1">
              <Link
                to="/Dashboard/AddProducts"
                className={`list-group-item list-group-item-action ${pathname === "/Dashboard/AddProducts" ? "active" : ""}`}
                onClick={closeSidebar}
              >
                <FaBox /> Products
              </Link>

              <Link
                to="/Dashboard/CategoriesItemsAdmin"
                className={`list-group-item list-group-item-action ${pathname === "/Dashboard/CategoriesItemsAdmin" ? "active" : ""}`}
                onClick={closeSidebar}
              >
                <FaTags /> Categories
              </Link>

              <Link
                to="/Dashboard/UserRegistrations"
                className={`list-group-item list-group-item-action ${pathname === "/Dashboard/UserRegistrations" ? "active" : ""}`}
                onClick={closeSidebar}
              >
                <FaUserFriends /> User Registrations
              </Link>
            </div>

            <div className="mt-auto p-3 border-top border-secondary border-opacity-25">
              <Link
                to="/"
                target="_blank"
                className="btn sidebar-footer-btn btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2 py-2.5 fw-semibold"
                style={{ fontSize: '12px' }}
                onClick={closeSidebar}
              >
                <FaExternalLinkAlt size={12} /> View Main Website
              </Link>
            </div>
          </div>

          {/* Overlay */}
          {isToggled && <div className="overlay" onClick={closeSidebar}></div>}

          {/* Page Content */}
          <div id="page-content-wrapper">
            <Navbar className="navbar border-bottom shadow-sm bg-white">
              <div className="container-fluid px-md-4">
                <Button
                  variant="light"
                  className="ms-0 shadow-none d-flex align-items-center justify-content-center p-0"
                  id="sidebarToggle"
                  onClick={handleToggle}
                  style={{ width: "40px", height: "40px", border: "1px solid #E2E8F0", backgroundColor: "#fff", borderRadius: "10px" }}
                >
                  <FaBars size={18} style={{ color: "#0F172A" }} />
                </Button>

                <div className="ms-3 d-none d-sm-flex align-items-center gap-2">
                  <span className="fw-bold text-dark fs-6">Admin Control Panel</span>
                </div>

                <div className="ms-auto d-flex align-items-center">
                  <DropdownButton
                    align="end"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <FaUser size={14} color="#C62828" /> <span className="d-none d-md-inline fw-bold text-dark">Admin</span>
                      </span>
                    }
                    id="dropdown-menu-align-end"
                    className="profile_icn"
                    variant="light"
                  >
                    <Dropdown.Header>Signed in as</Dropdown.Header>
                    <Dropdown.ItemText className="fw-bold mb-2 text-danger" style={{ fontSize: '13px' }}>{username}</Dropdown.ItemText>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2 text-danger fw-semibold">
                      <FaSignOutAlt /> Logout
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
            </Navbar>

            <div className="container-fluid mt-4 pb-5 px-md-4">
              <Outlet />
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default DashboardLayout;
